/** Shell nav href for Sync (opens the Actualizar tab by default). */
export const SHELL_SYNC_NAV_HREF = '/sync?tab=update';

/** Pathname used for active-state matching and RBAC on Sync routes. */
export const SHELL_SYNC_NAV_PATH = '/sync';

/** Pathname only (ignores `?tab=` and hash). */
export function shellNavPathname(path: string): string {
  const trimmed = path.trim();
  if (!trimmed.startsWith('/')) return trimmed;
  const q = trimmed.indexOf('?');
  const h = trimmed.indexOf('#');
  const end = q === -1 ? (h === -1 ? trimmed.length : h) : h === -1 ? q : Math.min(q, h);
  return trimmed.slice(0, end) || '/';
}
